import { CellContext } from '@tanstack/react-table';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

interface NestedWaitlistClientValue {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

/** Zwykły tekst, bo zapis na liście oczekujących nie ma własnego ekranu. */
export const nestedWaitlistClientFieldRender = <T,>(
  info: CellContext<T, unknown>,
) => {
  const value = info.getValue() as NestedWaitlistClientValue | null | undefined;
  // jOOQ oddaje brak wiersza jako obiekt z samymi `null`-ami, nie jako `null`.
  if (!value?.id) return <EmptyValue />;
  return `${value.firstName} ${value.lastName}`;
};
